export default __webpack_public_path__ + "static/media/bg-left.224ef4ab.svg";